import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import Loading from "./Shared/components/loading";
import { Routes } from "./Shared/components/Navigation/navigationUtils";
/**
 * Wraps any route(s) that require authentication.
 * If the user is authenticated it will redirect back to the route they were on. Otherwise it will redirect to login/register.
 *
 * @returns
 */
export const RequireAuth = () => {
    const location = useLocation();
    const authContext = useAuth();
    const { isAuthenticated, loading } = authContext;
    if (loading) {
        return _jsx(Loading, { viewportHeight: "75vh" });
    }
    return isAuthenticated ? (_jsx(Outlet, {})) : (_jsx(Navigate, { to: Routes.LOGIN, state: Object.assign(Object.assign({}, location.state), { prevRoute: `${location.pathname}${location.search}` }), replace: true }));
};
